module.exports = __webpack_public_path__ + "static/media/graphQL.fa054c6d.png";